import React from 'react';
import { useForm } from 'react-hook-form';
import CrudCreate from '~/components/CrudCreate';
import IOrganization from '../interfaces/IOrganization';
import Layout from '~/components/Layout';

export default function Create() {     
  const {register, handleSubmit, control, setValue:setFormValue} = useForm<IOrganization>();
  const fields = [
      { name: 'name', type: 'string'},
      { name: 'acronym', type: 'string'},
      { name: 'notes', type: 'string'},
      { name: 'is_public', type: 'boolean'},           
  ];
  
    return(
      <Layout marginLayout={true}>
        <CrudCreate model={'organization'} 
        fields={fields} 
        register={register} 
        handleSubmit={handleSubmit} 
        control={control} 
        messageSuccess={'Organization successfully created!'}  
        title={'Add organization'}  
        subheader={'Add organization'}
        setFormValue={setFormValue} />
      </Layout>
    )
}
